var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiContainer20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    part: "icon",
    id: "mi-container",
    shapeRendering: "geometricPrecision",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5zm15 0H3v10h14V5zM6 12V8h1v4H6zm3.5 0V8h1v4h-1zm3.5 0V8h1v4h-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiContainer20Px);
export default __webpack_public_path__ + "static/media/mi-container-20px.fb72967111213d33f66a2054cbc959cc.svg";
export { ForwardRef as ReactComponent };